var BindingScopeEnum = {
    Request: "Request",
    Singleton: "Singleton",
    Transient: "Transient"
};
var BindingTypeEnum = {
    ConstantValue: "ConstantValue",
    Constructor: "Constructor",
    DynamicValue: "DynamicValue",
    Factory: "Factory",
    Function: "Function",
    Instance: "Instance",
    Invalid: "Invalid",
    Provider: "Provider"
};
var TargetTypeEnum = {
    ClassProperty: "ClassProperty",
    ConstructorArgument: "ConstructorArgument",
    Variable: "Variable"
};
export { BindingScopeEnum, BindingTypeEnum, TargetTypeEnum };
//# sourceMappingURL=literal_types.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/constants/literal_types.js
// module id = 141
// module chunks = 0